import { UserAction } from "@brookbush/types";

import { deleteCookie, setCookie } from "cookies-next";
import { useRouter } from "next/compat/router";
import { create } from "zustand";

import useUserFlags from "./useUserFlags";
import {
	dismissSignupModal,
	shouldShowSignupModal,
} from "~/lib/signup-modal.lib";

interface UserActionState {
	userAction: UserAction | null;
	setUserAction: (action: UserAction | null) => void;
	resetUserAction: () => void;
}

const useUserActionStore = create<UserActionState>((set) => ({
	userAction: null,
	setUserAction: (userAction) => set({ userAction }),
	resetUserAction: () => set({ userAction: null }),
}));

const useUserAction = () => {
	const {
		userAction,
		setUserAction: setStoreUserAction,
		resetUserAction: resetStoreUserAction,
	} = useUserActionStore();

	const { userFlags, updateFlag } = useUserFlags();

	const resetUserAction = async () => {
		if (
			(userAction === UserAction.SIGN_UP ||
				userAction === UserAction.WELCOME) &&
			shouldShowSignupModal()
		) {
			dismissSignupModal();
		} else if (
			userAction === UserAction.BECOME_A_MEMBER &&
			userFlags?.shouldShowConversionModal
		) {
			await updateFlag({
				shouldShowConversionModal: false,
			});
		}

		resetStoreUserAction();

		deleteCookie("audited-course-id");
		deleteCookie("audited-video-id");
		deleteCookie("audited-glossary-term-id");
		deleteCookie("is-trial-user");
		deleteCookie("selected-webinar-id");
	};

	const { asPath } = useRouter() ?? { asPath: "" };
	const path = asPath.split("?")[0];

	const setUserAction = (value?: UserAction | null | undefined) => {
		if (value === UserAction.SIGN_UP && path === "/trial-membership") {
			setCookie("is-trial-user", "true");
		}

		setStoreUserAction(value as UserAction);
	};

	return {
		userAction,
		setUserAction,
		resetUserAction,
	};
};

export default useUserAction;
